import { useResendVerificationEmail } from "@src/components/user/mutations/resend-verification-email";
import {
	showErrorNotification,
	showSuccessNotification,
} from "@src/utils/notifications";
import { useCallback } from "react";

export function useResendVerificationEmailAction() {
	const { mutateAsync, isPending } = useResendVerificationEmail();

	const handleResend = useCallback(async () => {
		try {
			await mutateAsync();
			showSuccessNotification(
				"Email sent",
				"Check your inbox for the verification link.",
			);
		} catch {
			showErrorNotification("Couldn't resend", "Try again in a moment.");
		}
	}, [mutateAsync]);

	return { handleResend, isPending };
}
